// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NRAb1I {
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-3);
  padding-right: var(--spacing-2);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: var(--spacing-1);
  }
  &::-webkit-scrollbar-thumb {
    width: var(--spacing-1);
    background-color: var(--text-neutral-subtle);
    border-radius: var(--radius-m);
  }
}

.LyuuEh {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-0-5);
}

.jLvsob {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.lj3Oso {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: var(--spacing-0-5);
}

.YKZgcg {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.ppuPVC {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-0-5);
}

.xdnTeQ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.D9iaZ4 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ExtractList/ExtractList.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC","sourcesContent":[".extractList {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-3);\n  padding-right: var(--spacing-2);\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: var(--spacing-1);\n  }\n  &::-webkit-scrollbar-thumb {\n    width: var(--spacing-1);\n    background-color: var(--text-neutral-subtle);\n    border-radius: var(--radius-m);\n  }\n}\n\n.extractGroup {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.dateHeader {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.dateContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.date {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.balanceContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-0-5);\n}\n\n.balanceLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.balance {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extractList": `NRAb1I`,
	"extractGroup": `LyuuEh`,
	"dateHeader": `jLvsob`,
	"dateContainer": `lj3Oso`,
	"date": `YKZgcg`,
	"balanceContainer": `ppuPVC`,
	"balanceLabel": `xdnTeQ`,
	"balance": `D9iaZ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
